import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

interface OpenEvent extends Event {
  params: {
    frameId: string
    pageUrl?: string
    title?: string
    url: string
  }
}

interface SidePanelToggleEvent extends Event {
  detail: {
    isOpen: boolean
  }
}

export default class extends Controller<HTMLDivElement> {
  static targets = ['popover', 'title']
  static values = {
    autoOpenTitle: String,
    autoOpenUrl: String,
    frameId: String,
    stateParamKey: String
  }

  declare readonly autoOpenTitleValue: string
  declare readonly autoOpenUrlValue: string
  declare readonly frameIdValue: string
  declare readonly stateParamKeyValue: string
  declare readonly hasAutoOpenTitleValue: boolean
  declare readonly hasAutoOpenUrlValue: boolean
  declare readonly hasFrameIdValue: boolean
  declare readonly hasStateParamKeyValue: boolean
  declare readonly popoverTarget: HTMLElement
  declare readonly hasPopoverTarget: boolean
  declare readonly titleTarget: HTMLElement
  declare readonly hasTitleTarget: boolean

  connect(): void {
    if (!this.hasAutoOpenUrlValue || !this.hasFrameIdValue) return

    this.#openPanelAndLoad(
      this.hasAutoOpenTitleValue ? this.autoOpenTitleValue : null,
      this.frameIdValue,
      this.autoOpenUrlValue
    )
  }

  open(event: OpenEvent): void {
    event.preventDefault()

    const { frameId, pageUrl, title, url } = event.params

    if (pageUrl !== undefined) {
      window.history.replaceState({}, '', pageUrl)
    }

    this.#openPanelAndLoad(title ?? null, frameId, url)
  }

  handleSidePanelToggle(event: SidePanelToggleEvent): void {
    if (event.detail.isOpen || !this.hasStateParamKeyValue) return

    const url = new URL(window.location.href)
    url.searchParams.delete(this.stateParamKeyValue)
    window.history.replaceState({}, '', url)
  }

  #openPanelAndLoad(title: string | null, frameId: string, url: string): void {
    if (this.hasTitleTarget && title !== null) {
      this.titleTarget.textContent = title
    }

    if (this.hasPopoverTarget && this.popoverTarget.matches(':popover-open') !== true) {
      this.popoverTarget.showPopover()
    }

    Turbo.visit(url, { frame: frameId })
  }
}
